import React from 'react';

import CustomSelectableDropdown from '@components/CustomSelectableDropdown';

import { ORGANIZTION_INFO } from '@utils/Util';

const PomDetailsBrands = ({
	allBrandList,
	selectedBrandList,
	setSelectedBrandList,
	setSearchBrand,
	isBrandOnly,
	setIsBrandOnly,
	errors
}) => {
	const onUpdatedList = (dataIndex, updatedValue, updateKey) => {
		const updatedList = selectedBrandList?.map((item, index) => {
			if (index === dataIndex) {
				return {
					...item,
					[updateKey]: updatedValue
				};
			} else {
				return item;
			}
		});
		setSelectedBrandList(updatedList);
	};
	return (
		<div className="pom-brand-table scroll-x-label">
			<h3 className="semibold-14 gray_dark_01">POM details for brands</h3>
			<table className="table with-border height-sm no-hover projection-list-table">
				<thead>
					<tr>
						<th>Brand*</th>
						<th>POM Code*</th>
						<th>POM*</th>
						<th>How to measure</th>
						<th>Tolerance (CM)</th>
						<th />
					</tr>
				</thead>
				<tbody>
					{selectedBrandList?.map((item, idx) => (
						<tr key={item?.brandId[0]?.value}>
							<td className="brand">
								<div className="no-shadow-react-select">
									<CustomSelectableDropdown
										allOptions={allBrandList}
										setSelectedOptions={(data) => {
											onUpdatedList(idx, data, 'brandId');
										}}
										selectedOptions={item?.brandId}
										isMulti={false}
										placeholder="Select"
										onInputChange={setSearchBrand}
										isDisabled={item?.brandId[0]?.label === ORGANIZTION_INFO?.name}
									/>
								</div>
								{errors[`brandId_${idx}`] && (
									<p className="error">{errors[`brandId_${idx}`]}</p>
								)}
							</td>
							<td className="pom-input-code">
								<input
									type="text"
									value={item.pomCode}
									onChange={(e) => onUpdatedList(idx, e.target.value, 'pomCode')}
								/>
								{errors[`pomCode_${idx}`] && (
									<p className="error">{errors[`pomCode_${idx}`]}</p>
								)}
							</td>
							<td className="pom-input">
								<input
									type="text"
									value={item?.pomName}
									onChange={(e) => onUpdatedList(idx, e.target.value, 'pomName')}
								/>
								{errors[`pomName_${idx}`] && (
									<p className="error">{errors[`pomName_${idx}`]}</p>
								)}
							</td>
							<td className="measure-td">
								<input
									type="text"
									value={item?.howToMeasure}
									onChange={(e) => onUpdatedList(idx, e.target.value, 'howToMeasure')}
								/>
							</td>
							<td>
								<input
									type="number"
									placeholder="TOL(+/-)"
									value={item?.tolerance || null}
									onChange={(e) => onUpdatedList(idx, Number(e.target.value), 'tolerance')}
								/>
							</td>
							<td className="cursor-pointer">
								{idx !== 0 && (
									<div className="edit-items">
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													<img
														src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`}
														alt="tee"
													/>
												</button>
												<ul
													className="dropdown-menu dropdown-menu-right shadow-lg"
													role="menu"
													onClick={() =>
														setSelectedBrandList(
															selectedBrandList?.filter?.(
																(data, dataIndex) => dataIndex !== idx
															)
														)
													}
												>
													<li role="presentation" className="px-4 pb-3">
														<span className="font-weight-normal red ">
															Delete
														</span>
													</li>
												</ul>
											</div>
										</div>
									</div>
								)}
							</td>

							{/* {errors.pomBodyPartError && (
										<p className="error">{errors.pomBodyPartError}</p>
									)} */}
						</tr>
					))}

					<tr>
						<td colSpan={6}>
							<button
								disabled={isBrandOnly}
								className="cursor-pointer btn btn-default"
								onClick={() =>
									setSelectedBrandList([
										...selectedBrandList,
										{
											brandId: [],
											pomCode: '',
											pomName: '',
											howToMeasure: '',
											tolerance: null
										}
									])
								}
							>
								<span>
									<img
										src={`${process.env.PUBLIC_URL}/icons/plus-20.svg`}
										alt="svg"
										width="20px"
									/>
								</span>
								Brand
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<div className="col-md-12  p-0">
				<div className="country-group custom-chekbox d-flex justify-content-start align-items-center">
					<div className="form-group">
						<input
							type="checkbox"
							id="only"
							name="only"
							onChange={() => setIsBrandOnly(!isBrandOnly)}
							checked={isBrandOnly}
							disabled={selectedBrandList?.length > 2}
						/>
						<label className="regular-14" htmlFor="only">
							<span>Only for this brand</span>
						</label>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PomDetailsBrands;
